module.exports = __webpack_public_path__ + "img/IMG_2729_L_Wood_MockedUp.3c5eb350.jpg";